export default {
      id: "grabber-usage",
      viewBox: "0 0 32 23",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#grabber",
      toString: function () {
        return this.url;
      }
    }